import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.scss']
})
export class DeleteConfirmationModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Confirm Delete';
  @Input() message: string = 'Are you sure you want to delete this item?';
  @Input() itemName?: string;
  @Input() itemDetails?: { label: string; value: any }[]; // Array of detail objects to display
  @Input() itemType: string = 'item'; // e.g., 'employee', 'customer', 'vendor', 'machine'
  @Input() loading: boolean = false;
  @Input() deleteButtonText: string = 'Delete';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() iconClass: string = 'icon-trash-2'; // Feather icon class
  @Input() warningMessage?: string; // Additional warning message (e.g., for delivered items)
  @Input() showWarningAlert: boolean = false; // Show additional warning alert

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}

